 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A01COVERPAGE from '@/components/001-coverpage'
 import LOVE_1 from '@/components/love_1'
 import A02TITLEPAGE from '@/components/002-titlepage'
 import A03DEDICATION from '@/components/003-dedication'
 import A04TOC from '@/components/004-toc'
 import A05INTRODUCTION from '@/components/005-introduction'
 import A06CHAPTER1 from '@/components/006-chapter1'
 import A07CHAPTER2 from '@/components/007-chapter2'
 import A08CHAPTER3 from '@/components/008-chapter3'
 import A09CHAPTER4 from '@/components/009-chapter4'
 import A10CHAPTER5 from '@/components/010-chapter5'
 import A11CHAPTER6 from '@/components/011-chapter6'
 import LOVE_2 from '@/components/love_2'
 import A12SUGGESTEDPAIRINGS from '@/components/012-suggestedpairings'
 import A13INDEX from '@/components/013-index'
 import A14TABLE from '@/components/014-table'
 import A15ABOUTTHEAUTHOR from '@/components/015-abouttheauthor'
 import A16COPYRIGHT from '@/components/016-copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/004-toc",
 			"name" : "004-toc",
 			"component" : A04TOC
 		},
 		{
 			"path" : "/005-introduction",
 			"name" : "005-introduction",
 			"component" : A05INTRODUCTION
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js